import PropTypes from "prop-types";
import SelectMultipleWithOrdering from "./common/select-multiple-with-ordering";

function InputRelationalNtoNOrdering(props) {
  return <SelectMultipleWithOrdering {...props} />;
}

InputRelationalNtoNOrdering.propTypes = {
  className: PropTypes.string,
  control: PropTypes.object,
  id: PropTypes.string,
  isNullable: PropTypes.bool,
  name: PropTypes.string,
  permittedValues: PropTypes.array,
  required: PropTypes.bool,
  value: PropTypes.array,
};

export default InputRelationalNtoNOrdering;
